import GetShopArticleTaxHistoryByIdRequestModelBase from '../_generated/modelBases/get-shop-article-tax-history-by-id-request-model-base';

export default class GetShopArticleTaxHistoryByIdRequestModel extends GetShopArticleTaxHistoryByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
